export const DomainConfig = {
  development: {
    host: 'http://test-nfwmessage.southcn.com/',
  },
  production: {
    host: 'http://app.southcn.com/nfw_message/',
  },
}
